export const endPoints = {
  EXPO_ALL_NOT_PRINTED: '/v1/expo/all-not-printed',
  EXPO_ALL: '/v1/expo/all'
};
